const validate = (values: any) => {
    const errors: {
        flaggedReason: any,
        naReason:any;        
      } = {
        flaggedReason: undefined,
        naReason: undefined
      };
      if (!values.flaggedReason || (values.flaggedReason && values.flaggedReason.length < 10)) {
        errors.flaggedReason = "*Enter minimum 10 characters";
      }
      if(!values.naReason || (values.naReason && values.naReason.length < 10)){
        errors.naReason = "*Enter minimum 10 characters";
      }
      return errors;
      
}
export default validate;
